import React from 'react'

export default class PageSubTitle extends React.Component {
    render() {
        return(
            <h5 name="PageSubTitle" className={['page-sub-title', this.props.className].join(' ')}>{this.props.children}</h5>
        )
    }
}
